<template>
<div class="chapter">
<div class="inner_page">
<p class="p6">Dedicato a tutti i nativi americani che lottano per preservare il loro patrimonio culturale, il loro modo di vivere e la loro dignità.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?60b55c98